<template>
  <div class="app-layout">
    <AppSidebar />
    <AppNavbar :breadcrumbs="breadcrumbs" />
    <slot></slot>
  </div>
</template>

<script>
import AppNavbar from '../app/AppNavbar.vue';
import AppSidebar from '../app/AppSidebar.vue';

export default {
  name: 'AppLayout',
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  },
  components: { AppSidebar, AppNavbar }
}
</script>

<style scoped>
.app-layout {
  padding-left: var(--app-sidebar-width);
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>